import React from 'react';
import { useSetLocale, useGetIdentity, useLocaleState } from 'react-admin';
import { MenuItem, Select, SelectChangeEvent, FormControl, Box } from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';
import { AvailableLanguage, saveLanguagePreference } from '../i18n';

export const LanguageSwitcher = () => {
  const setLocale = useSetLocale();
  const { data: identity } = useGetIdentity();
  const [locale] = useLocaleState();
  
  // Use React Admin's locale state or fallback to localStorage
  const currentLocale = locale || localStorage.getItem('RaStore.locale') || 'en';
  
  const handleChange = async (event: SelectChangeEvent<string>) => {
    const newLocale = event.target.value as AvailableLanguage;
    
    // Update React Admin locale immediately for instant feedback
    setLocale(newLocale);
    
    // Save preference to backend and localStorage
    await saveLanguagePreference(newLocale, identity?.id?.toString());
  };
  
  return (
    <FormControl size="small" sx={{ minWidth: 150 }}>
      <Select
        value={currentLocale}
        onChange={handleChange}
        displayEmpty
        startAdornment={
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
            <LanguageIcon fontSize="small" sx={{ color: '#606060' }} />
          </Box>
        }
        sx={{
          height: 36,
          backgroundColor: '#F8F9FA',
          '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #E8E8E8',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#00C853',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#00C853',
          },
        }}
      >
        <MenuItem value="en">English</MenuItem>
        <MenuItem value="zh-TW">繁體中文</MenuItem>
      </Select>
    </FormControl>
  );
};